<template>
  <v-container>
    <v-layout>
<!--      <v-flex xs1>-->
<!--        <v-select :color="Theme.GREEN"-->
<!--                  :items="getFilterType"-->
<!--                  :label="'篩選'"-->
<!--                  item-text="text" item-value="key"-->
<!--                  v-model="filter"-->
<!--                  @change="changeFilterType()"/>-->
<!--      </v-flex>-->
      <v-flex>
        <v-text-field v-model="searchValue" label="搜尋"
                      :color="Theme.GREEN" placeholder="查詢標題"></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn class="mr-2" :color="Theme.GREEN" dark @click.prevent="searchEvent">搜尋</v-btn>
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn style="float: right;" :color="Theme.PINK" dark @click.prevent="addNew">新增</v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <sale-detail
        :title="editView.title"
        :visible="editView.visible"
        :item-detail="editView.item"
        :show-cancel="editView.showCancel"
        :isEdit="editView.key"
        @cancelEvent="editView.cancelEvent"
        @confirmEvent="editView.confirmEvent"
      @successEvent="editView.successEvent"/>
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";
import SaleDetail from "./SaleDetail";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";

export default {
  name: "sale",
  components: {
    TableView, SaleDetail
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      filter: -1,
      searchValue:'',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        key: 'add',
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
        successEvent: ()=>{}
      },
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters([]),
    getColumnKeys(){
      return [
        { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        { value:'title', text:'標題' },
        // { value:'enable', text:'是否啟用', sortable: false },
        { value:'createdDate', text:'建立時間', sortable: false },
        { value:'delete', text:'刪除' , isEvent: true, color: this.Theme.YELLOW, sortable: false },
      ]
    }

  },
  methods:{
    ...mapActions(['getSalePageList','deleteSaleInfo']),
    changeFilterType(){
      this.loadData();
    },
    async loadData(){
      this.loading = true;
      const res = await this.getSalePageList({
        pageIndex: this.pagination.page,
        limit: this.pagination.itemsPerPage,
        searchValue:this.searchValue,
      });

      if (res.data.code === 0){
        this.list = res.data.body.list;
        this.pagination.totalItems = res.data.body.header.totalCount;

        console.log(`getSaleList ${JSON.stringify(res.data.body.list)}`);
      }
      this.loading = false;
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page){
      this.pagination.page = page.page;
      this.pagination.itemsPerPage = page.itemsPerPage;
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'delete'){
        this.showAlert({
          title: '提示',
          content: '是否確定要刪除此項目？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          }
        });
      } else {
        this.editView.title = cell.key === 'add' ? '新增促銷頁面':'修改促銷頁面';
        let itemDetail = Object.assign({}, cell.item);
        if (!itemDetail.linkList) {
          itemDetail.linkList = [];
        }
        if (!itemDetail.imageURL) {
          itemDetail.imageURL = '';
        }
        if (!itemDetail.content) {
          itemDetail.content = '';
        }
        this.editView.key = cell.key;
        this.editView.item = itemDetail;
        this.editView.visible = true;
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
        this.editView.successEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        };
      }

    },
    searchEvent(){
      this.loadData();
    },
    reset(){
      this.searchValue = '';
      this.loadData();
    },
    async deleteEvent(item){
      const res = await this.deleteSaleInfo({
        pageId: item.pageId,
      });

      if (res.data.code === 0){
        this.reset();
      }
    },
    addNew(){
      this.cellEvent({
        key: 'add',
        item: {
          pageId: this.uuid.v4(),
          title:'',
          content:'',
          imageURL:'',
          linkList:[],
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
